import { secureGet, securePost } from 'config/apiConfig';

export const getReglements = async ({
  page = 0, size = 10, sort = 'rgDateEcheance,desc',
  search = '', types = [], statuts = [],
  startEcheance = '', endEcheance = '',
}) => {
  const params = new URLSearchParams({ page, size, sort });
  const body = {};
  if (search) body.search = search;
  if (types.length > 0) body.types = types;
  if (statuts.length > 0) body.statuts = statuts;
  if (startEcheance) body.startEcheance = startEcheance;
  if (endEcheance) body.endEcheance = endEcheance;
  const { data } = await securePost(`/reglements/search?${params.toString()}`, body);
  return data;
};

export const getReglementById = async (id) => {
  const { data } = await secureGet(`/reglements/${id}`);
  return data;
};

export const getReglementDocument = async (id) => {
  const { data } = await secureGet(`/reglements/${id}/document`);
  return data;
};

export const getReglementCertificate = async (id) => {
  const { data } = await secureGet(`/reglements/${id}/certificate`);
  return data;
};
